import React from 'react';
import { useTranslation } from 'react-i18next';
import './LegalPage.css';

export default function PrivacyPage() {
    const { t } = useTranslation();
    const sections = t('privacy.sections', { returnObjects: true });

    return (
        <div className="legal-page">
            <h1>{t('privacy.title')}</h1>
            <p className="legal-subtitle">{t('privacy.updated')}</p>
            {sections.map((section) => (
                <section key={section.heading}>
                    <h2>{section.heading}</h2>
                    {section.paragraphs.map((paragraph, i) => (
                        <p key={i}>{paragraph}</p>
                    ))}
                </section>
            ))}
        </div>
    );
}
